(function($) {
  "use strict";

  let webpSupport = true;
  async function supportsWebp() {
    if (!self.createImageBitmap) return false;

    const webpData =
      "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=";
    const blob = await fetch(webpData).then((r) => r.blob());
    return createImageBitmap(blob).then(
      () => true,
      () => false
    );
  }

  (async () => {
    if (await supportsWebp()) {
      webpSupport = true;
    } else {
      webpSupport = false;
    }
  })();

  const webpfallback = () => {
    if (webpSupport == true) return;

    $(once("webp-fallback", "source[data-webp-fallback]")).each(function() {
      let srcSet = $(this).data("srcset");

      // file type : todo improve
      let fileType = "jpg";
      if (srcSet.includes(".png.webp")) {
        fileType = "png";
      } else if (srcSet.includes(".gif.webp")) {
        fileType = "gif";
      } else if (srcSet.includes(".jpeg.webp")) {
        fileType = "jpeg";
      }
      let srcSetFallback = srcSet.replace(/.webp?/g, "?");

      let source = `<source srcset="data:,x"  data-srcset="${srcSetFallback}" type="image/${fileType}" >`;

      $(this).after(source);
    });
  };

  // ATTACH
  Drupal.behaviors.webpFallback = {
    attach: function(_context) {
      webpfallback();
    },
  };
})(jQuery);
